import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import 'index.css';
import App from 'App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { persistor, store } from 'store';
import * as serviceWorker from 'serviceWorker';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'react-dropzone-uploader/dist/styles.css';
import ErrorBoundary from 'ErrorBoundry';
import { AdTrayProvider } from 'contexts/AdTrayContext';
import { LocationProvider } from 'contexts/LocationContext';
import { TourProvider } from 'tour/TourProvider';
import TourOverlay from 'tour/TourOverlay';

ReactDOM.hydrate(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <React.StrictMode>
          <Router>
            <LocationProvider>
              <AdTrayProvider>
                <TourProvider>
                  <TourOverlay />
                  <App />
                </TourProvider>
              </AdTrayProvider>
            </LocationProvider>
          </Router>
        </React.StrictMode>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

serviceWorker.unregister();
